export default {"src":"/_next/static/media/bonus-completed-celebration.3c39e5a6.gif","height":110,"width":110,"blurWidth":0,"blurHeight":0};